import { Column } from '@tanstack/react-table';
import classNames from 'classnames';
import FilterIcon from '@images/svg/filter.svg?react';
import CrossIcon from '@images/svg/close.svg?react';
import DebouncedInput from '@components/primitives/dataGrid/components/DebouncedInput';

interface Props<TData> {
    column: Column<TData>;
}

const TextFilter = <TData extends object>({ column }: Props<TData>) => {
    const columnFilterValue = column.getFilterValue() as string | undefined;

    const onReset = () => {
        column.setFilterValue(undefined);
    };

    return (
        <div
            className={classNames('gridFilter', 'gridFilter--default', {
                'gridFilter--active': columnFilterValue,
            })}
        >
            <DebouncedInput
                className="defaultGridFilter"
                value={columnFilterValue || ''}
                onChange={(value) => column.setFilterValue(value)}
                type="text"
                name={`filter-${column.id}`}
                data-lpignore="true"
            />
            {!columnFilterValue ? (
                <FilterIcon className="defaultGridFilter__icon" />
            ) : (
                <button type="button" tabIndex={-1} className="defaultGridFilter__reset" onClick={onReset}>
                    <CrossIcon />
                </button>
            )}
        </div>
    );
};

export default TextFilter;
